import clsx from "clsx";

export function BulletSteps({
	steps,
	selectedIndex,
	navRef,
}: {
	steps: Record<string, any>;
	selectedIndex: number;
	navRef?: boolean;
}) {
	return (
		<nav
			className={clsx(
				navRef ? "eF-mb-3" : "eF-mb-0",
				"eF-text-[--eF-theme-accent] eF-flex eF-items-center eF-justify-center",
			)}
			aria-label="Progress"
		>
			{steps.map((step: any) => (
				<p
					key={step.id}
					className="!eF-pb-0 eF-text-[--theme-accent] eF-text-md eF-font-medium eF-leading-4"
				>
					{step.id < selectedIndex ? "" : step.id === selectedIndex ? step.name : ""}
				</p>
			))}
			<ol
				role="list"
				className="!eF-mb-0 eF-ml-5 eF-mr-5 eF-flex eF-items-center eF-space-x-3 sm:eF-space-x-5 sm:eF-ml-8"
			>
				{steps.map((step: any) => (
					<li key={step.id} className="!eF-list-none !eF-pb-0">
						{step.id < selectedIndex ? (
							<button
								className="eF-block eF-h-2.5 eF-w-2.5 eF-rounded-full eF-bg-[--eF-theme-color] eF-hover:bg-[--eF-hover-color]"
								aria-label={step.name}
							>
								<span className="eF-sr-only"></span>
							</button>
						) : step.id === selectedIndex ? (
							<button
								className="eF-relative eF-flex eF-items-center eF-justify-center"
								aria-label={step.name}
								aria-current="step"
							>
								<span
									className="eF-absolute eF-flex eF-h-5 eF-w-5 eF-p-px"
									aria-hidden="true"
								>
									<span className="eF-h-full eF-w-full eF-rounded-full eF-bg-[--eF-bullet-bg]" />
								</span>
								<span
									className="eF-relative eF-block eF-h-2.5 eF-w-2.5 eF-rounded-full eF-bg-[--eF-theme-color]"
									aria-hidden="true"
								/>
								<span className="eF-sr-only"></span>
							</button>
						) : (
							<button
								className="eF-block eF-h-2.5 eF-w-2.5 eF-rounded-full eF-bg-gray-200 hover:eF-bg-gray-400"
								aria-label={step.name}
							>
								<span className="eF-sr-only"></span>
							</button>
						)}
					</li>
				))}
			</ol>
		</nav>
	);
}
